var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGeneralCertificationPurchase = function SvgGeneralCertificationPurchase(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF540F",
    fillRule: "evenodd",
    d: "M7 4.5V1.73c0-.706-.792-1-1.156-.429l-3.22 5.043c-.308.48-.006 1.156.517 1.156H5v2.77c0 .706.792 1 1.156.429l3.22-5.043c.308-.48.006-1.156-.517-1.156z",
    clipRule: "evenodd"
  })));
};
export default SvgGeneralCertificationPurchase;